import { render, staticRenderFns } from "./deduction-report.vue?vue&type=template&id=ea75c40c"
import script from "./deduction-report.vue?vue&type=script&lang=js"
export * from "./deduction-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports